import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
	PayPalNameField,
	PayPalNumberField,
	PayPalExpiryField,
	PayPalCVVField,
	usePayPalCardFields
} from "@paypal/react-paypal-js";


const propTypes = {
	type: PropTypes.string,
};

const defaultProps = {
	type: 'text',
};

const PayPalFieldWrapper = styled.div`
	width: 100%;
	
	> div:first-child {
		width: 100% !important;
		max-width: 100% !important;
	}
	
	iframe {
		width: 100% !important;
		max-width: 100% !important;
	}
`;

function PaypalControl({ name, type, ...props }) {
	const inputProps = {
		name,
		id: name,
		'aria-describedby': `${name}Error`,
		...props,
	};
	const { cardFieldsForm, fields } = usePayPalCardFields();

	useEffect(() => {
		if (cardFieldsForm && fields && inputProps.invalid) {
			const triggerValidationStyles = async () => {
				try {
					let targetField = null;

					if (type === 'paypalNameField' && fields.NameField) {
						targetField = fields.NameField;
					} else if (type === 'paypalNumberField' && fields.NumberField) {
						targetField = fields.NumberField;
					} else if (type === 'paypalExpiryField' && fields.ExpiryField) {
						targetField = fields.ExpiryField;
					} else if (type === 'paypalCVVField' && fields.CVVField) {
						targetField = fields.CVVField;
					}

					if (targetField) {
						await targetField.addClass('invalid');
					}
				} catch (error) {
					console.log('Error applying PayPal field styles:', error);
				}
			};

			triggerValidationStyles();
		}
	}, [inputProps.invalid, type, cardFieldsForm, fields]);

	if (type === 'paypalNameField') {
		return <PayPalFieldWrapper ><PayPalNameField placeholder='Name on Card' /></PayPalFieldWrapper>;
	}

	if (type === 'paypalNumberField') {
		return <PayPalFieldWrapper><PayPalNumberField /></PayPalFieldWrapper>;
	}

	if (type === 'paypalExpiryField') {
		return <PayPalFieldWrapper ><PayPalExpiryField /></PayPalFieldWrapper>;
	}

	if (type === 'paypalCVVField') {
		return <PayPalFieldWrapper><PayPalCVVField /></PayPalFieldWrapper>;
	}
}

PaypalControl.propTypes = propTypes;
PaypalControl.defaultProps = defaultProps;

export default PaypalControl;
